import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { generateSrcSet } from '@/utils/imageUtils';
import clsx from 'clsx';
import { createBlurhash } from './ResizeImage.utils';
const ResizeImage = ({ image, loading = 'lazy', sizes, blurhashEnabled = true, imagePositioning, ...otherProps }) => {
    if (!image?.url)
        return;
    const imageCss = createBlurhash(image, blurhashEnabled);
    const baseUrl = image?.url;
    const srcSets = generateSrcSet({
        useCdn: image.useCdn,
        baseUrl: baseUrl,
        focalPoint: image.imageFocalPoint,
        sizes,
    });
    /*
     * Eager Loading:
     * - loading="eager" = Default behavior.
     * - decoding="sync" = Ensures the browser finishes decoding image before rendering anything else
     * - fetchPriority="high" = Forces image to be a high-priority resource before the browser realises it is in view
     *
     * Lazy Loading:
     * - loading="lazy" = Only fetch image when it enters the viewport.
     * - decoding="async" = Default behavior.
     * - fetchPriority="auto" = Default behavior.
     */
    const img = (_jsx("img", { ...otherProps, className: clsx(imagePositioning === 'focal' && 'object-cover', 'bg-cover', otherProps.className), alt: image.altText ?? '', "data-testid": "optiImage", decoding: loading === 'eager' ? 'sync' : 'async', fetchpriority: loading === 'eager' ? 'high' : 'auto', loading: loading, role: image.altText ? undefined : 'presentation', src: image.resize ? srcSets[0].src : baseUrl, style: imageCss }));
    if (!image.resize) {
        return img;
    }
    return (_jsxs("picture", { "data-testid": "optiImage", ...otherProps, children: [srcSets.map(({ id, media, src, srcHdpi, type }) => (_jsx("source", { media: media, srcSet: `${src}, ${srcHdpi} 2x`, type: type }, id))), img] }));
};
export default ResizeImage;
